import styled from '@emotion/styled';
import withStyleSystem from 'common/withStyleSystem';
import { Text, Paper } from 'common/styles';
import { __t } from 'common/i18n';
import { useUser } from 'common/CacheProvider';
import { paperBg } from './styles/Paper';

const Wrapper = styled(Paper)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background[paperBg.strong][0],
  padding: theme.spacing(1, 2),
}));

const CarrierWrapper = styled.div<{ isLarge?: boolean }>(({ theme, isLarge }) => ({
  width: '100%',
  marginTop: isLarge ? '1rem' : '0.5rem',
  fontSize: isLarge ? '14px' : '12px',
  color: isLarge ? theme.palette.text[800][0] : theme.palette.foreground[500][0],
  textAlign: isLarge ? 'center' : 'right',
}));

const SubscriptionStatus = ({ isLarge }: { isLarge?: boolean }) => {
  const { hasSubscription, subscriptionRemainingDays, user } = useUser();

  const handleSubscriptionStatus = () => {
    if (!hasSubscription) {
      return __t('profile.subscription.no_subscription');
    }

    const isCarrier = user?.conditional_flag === 'has_carrier_subscription';
    const carrierText = user?.carrier_subscription_title_text;

    if (isCarrier && carrierText) {
      return carrierText;
    }
    if (subscriptionRemainingDays <= 0) {
      return __t('subscription.less.one.day');
    }
    return __t('profile.subscription.remaining', { day: subscriptionRemainingDays });
  };

  if (user?.is_sso_login) return (
    <Wrapper>
      <Text variant="body2" color='weakSuccess' align="center">
        {user.carrier_subscription_title_text || __t('content.watch_free')}
      </Text>
    </Wrapper>
  );

  return (
    <>
      <Wrapper>
        <Text variant="body2" color={!hasSubscription ? 'weak' : subscriptionRemainingDays > 0 ? 'weakSuccess' : 'warning'} align="center">
          {handleSubscriptionStatus()}
        </Text>
      </Wrapper>
      {hasSubscription && subscriptionRemainingDays <= 0 && user?.carrier_subscription_menu_description_text &&
        <CarrierWrapper isLarge={isLarge}>{user?.carrier_subscription_menu_description_text}</CarrierWrapper>
      }
    </>
  );
};

export default withStyleSystem(SubscriptionStatus);
